<!-- 物流信息 -->
<template>
    <el-dialog title="物流信息" :visible.sync="dialogVisible" width="650px" 
            :before-close="handleClose" append-to-body>  
        <div style="margin-left: 30px;">
            <div class="size16">物流公司：{{ formData.logisticsName }}</div>
            <div class="size16" style="margin: 20px 0;">
                物流单号：{{ formData.logisticsNumber }}
                <el-button type="text" @click="handleCopy(formData.logisticsNumber)">复制</el-button>
            </div>
        </div>  
        <div style="margin-left: 30px;">
            <el-timeline :reverse="false">
                <el-timeline-item
                v-for="(activity, index) in lgsLineData"
                :key="index"              
                :color="index===0?'#F43809':''"
                :size="activity.size"
                :timestamp="activity.time">                
                <div :style="{ color: index === 0 ? '#F43809' : '' }">{{activity.context}}</div>
                </el-timeline-item>
            </el-timeline>
        </div>    
        <!--   :icon="activity.statusCode===3?'el-icon-success':'el-icon-error'"
            :type="activity.statusCode===6 || activity.statusCode===4?'danger':''"
            <div>
            <el-empty description="暂无物流信息"></el-empty>
        </div> -->
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">关闭</el-button>
        </span>
    </el-dialog>
</template>
    
<script>
export default {
    props: {
        formData: {
            type: Object,
            default: {}
        },
        info: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            dialogTitle: '',
            dialogVisible: true,
            logisticsData: {},
            isShow: false,
            lgsLineData: []
        }
    },
    created() {
        // console.log('组件的数据1', this.formData)  
        // console.log('组件的数据2', this.lgsLineData)  
    },
    mounted() { 
        // this.getLogisticsQuery(this.formData)   
        this.lgsLineData = this.info
        // console.log('组件的数据3',this.lgsLineData)  
     
    },
    methods: {
        getLogisticsQuery(row){
            let params = {
                opcode: this.$code.LogisticsQuery,
                i_goods_order: row.tradeId,
                i_no: row.orderId,
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    if(res.Data.SumCount > 0){
                        let list = res.Data.DataTable;
                        let result = list.map(item=>{
                            return{
                                index: item['订单序号'],
                                logisticsName: item['物流名称'],
                                logisticsNumber: item['物流订单号'],
                                logisticsId: item['订单流水号'],
                                status: item['物流状态'],
                                date: this.$help.formatDate(item['发货日期']),
                                time: this.$help.formatTime(item['发货时间']) ,
                                direction: item['方向'],
                            }
                        })
                        // let lgs = result.filter(i => i.direction === '退货')
                        let lgsDevliver = result.filter(i => i.direction === '发货')
                        this.logisticsData = lgsDevliver[0]  
                        this.isShow = true                     
                    }else{
                        this.isShow = false
                    }
                }else{
                    this.logisticsData = {}
                    this.isShow = false
                }
            })
        },       
        closeDialog(){             
            this.$emit('close');
            this.logisticsData = {}   
            this.lgsLineData = []     
        },
        handleClose(){
            this.$emit('close');
            this.logisticsData = {}   
            this.lgsLineData = []   
        },
        handleCopy(txt){
            this.$help.copyText(txt)    
            this.$message.success('复制成功！')       
        }
    },
}
</script>
<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/views/product/components/logisticsDialog.vue